import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import { blogArticles } from '../data/articles';

const Blog: React.FC = () => {
  return (
    <>
      <SEOHead
        title="ClipThis Blog"
        description="Insights on TikTok, YouTube Shorts, and AI editing workflows from the ClipThis team."
        url="/blog"
      />
      <BreadcrumbSchema items={[{ name: 'Blog', path: '/blog' }]} />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-5xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">Blog</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Stay ahead of algorithm shifts</h1>
          <div className="grid md:grid-cols-2 gap-6">
            {blogArticles.map((article) => (
              <article key={article.slug} className="p-6 rounded-2xl border border-gray-200 bg-gray-50 flex flex-col">
                <div className="text-xs text-gray-500 uppercase tracking-[0.2em] mb-2">{article.published}</div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">{article.title}</h2>
                <p className="text-gray-600 flex-1">{article.summary}</p>
                <div className="flex items-center justify-between text-sm text-gray-500 mt-4">
                  <span>{article.readingTime}</span>
                  <Link to={`/blog/${article.slug}`} className="text-red-600 font-medium hover:underline">
                    Read article →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Blog;

